module.exports = __webpack_public_path__ + "static/media/list.781e9cc4.svg";